import React, { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router";

export default function NudgeAlert() {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const nudgeCount = useMemo(() => {
    return user?.nudgeCount || 0;
  }, [user]);

  // Don't render if user is not authenticated
  if (!isAuthenticated || !user) {
    return null;
  }

  const handleClick = () => {
    navigate("/nudges");
  };

  return (
    <div className="relative flex justify-center bg-gray-100 min-w-11 rounded-full cursor-pointer hover:bg-gray-200">
      <button
        onClick={handleClick}
        className="relative p-2 text-gray-600 hover:text-gray-800 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-lg cursor-pointer"
        aria-label={`View notifications${nudgeCount > 0 ? ` (${nudgeCount} unread)` : ""}`}
      >
        <FontAwesomeIcon 
          icon={faBell} 
          className="text-2xl"
        />
        
        {nudgeCount > 0 && (
          <span className="absolute top-1 right-1 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white transform translate-x-1/2 -translate-y-1/2 bg-red-500 rounded-full min-w-[1.25rem] h-5">
            {nudgeCount > 99 ? "99+" : nudgeCount}
          </span>
        )}
      </button>
    </div>
  );
}
